import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const MobileToolbarRedoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={26}
        height={26}
        viewBox="0 0 26 26"
        className="Icon mobile-toolbar-redo"
        {...props}
    >
        <path
            fill="#D1D3D6"
            d="M18.958 8.623a.542.542 0 0 0 .88.423l4.008-3.206a.542.542 0 0 0 0-.846l-4.008-3.207a.542.542 0 0 0-.88.423l.001 2.393L13 4.604a9.75 9.75 0 0 0-9.746 9.463l-.004.287a9.75 9.75 0 0 0 9.75 9.75h3.792a.813.813 0 0 0 0-1.625H13a8.125 8.125 0 1 1 0-16.25h5.959v2.394z"
        />
    </svg>
);
const Memo = memo(MobileToolbarRedoIcon);
export default Memo;
